import { render, staticRenderFns } from "./TaxServices.handler.vue?vue&type=template&id=f8a58b74&"
import script from "./TaxServices.handler.vue?vue&type=script&lang=ts&"
export * from "./TaxServices.handler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports